<template>
	<div class="acu-point-list">
		<v-list flat>
			<div
				v-infinite-scroll="loadMore"
				infinite-scroll-disabled="loading"
				infinite-scroll-distance="0"
				v-if="infiniteScroll"
			>
				<AcuPointItem v-for="point in viewedList" :key="point.id" :point="point" @remove-point="removePoint" :grid="grid" :settings="settings" :edit="edit" :graphic="graphic" />
			</div>
			<AcuPointItem v-else v-for="point in list" :key="point.id" :point="point" @remove-point="removePoint" :grid="grid" :settings="settings" :edit="edit" :graphic="graphic" />
		</v-list>
	</div>
</template>

<script>
import AcuPointItem from "@/components/acupuncture/AcuPointItem.vue";
import infiniteScroll from "vue-infinite-scroll";

const ADD_ROW_AMOUNT = 10;

export default {
	name: "AcuPointList",
	props: ["list", "grid", "settings", "infiniteScroll", "edit", "graphic"],
	components: {
		AcuPointItem
	},
	directives: {
		infiniteScroll
	},
	data: () => ({
		loading: false,
		viewedList: []
	}),
	methods: {
		removePoint(point) {
			this.$emit("remove-point", point);
		},
		loadMore() {
			this.loading = true;
			var that = this;
			this.loadPoints(that);
		},
		loadPoints(that) {
			try {
				var total = this.list.length;
				let num_points_added = that.viewedList.length;

				var num_points_to_add = ADD_ROW_AMOUNT;
				if (total < num_points_added + num_points_to_add)
					num_points_to_add = total - num_points_added;

				for (
					var i = num_points_added;
					i < num_points_added + num_points_to_add;
					i++
				) {
					that.viewedList.push(that.list[i]);
				}
			} finally {
				that.loading = false;
			}
			that.loading = false;
		}
	},
	mounted() {
		if(this.infiniteScroll) this.loadPoints(this);
	}
};
</script>